import React, { useEffect, useState } from "react";
import Location from "../Location";
import Camera from "./Camera";
import classNames from "classnames/bind";
import styles from "./LiveCamera.module.css";
import { Toast } from "../../components";
import { useStoreContext } from "../../hooks/useStoreContext";
import { emptyCache } from "../../utils";
import CameraActive from "./CameraActive/CameraActive";
import { cameraManagement } from "../../services/api/cameraManagementApi";
import { screens } from "./Camera/Header/configScreen";

export const CameraContext = React.createContext({});

const cx = classNames.bind(styles);
const LiveCamera = () => {
  const [cameraSelect, setCameraSelect] = React.useState([]);
  const [isApply, setIsApply] = React.useState(false);
  const [toggleReGetListCamera, setToggleReGetListCamera] = useState(false);
  const [screen, setScreen] = React.useState({
    col: 1,
    row: 1,
    total: 1,
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [isGroup, setIsGroup] = useState(false);
  const [isLoadingCamera, setIsLoadingCamera] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [cameraActive, setCameraActive] = useState();
  const [isShowCameraActive, setIsShowCameraActive] = useState(false);
  const [dataStore, dispatch] = useStoreContext();
  const [stream, setStream] = useState([]);
  const [isOneCameraFullScreen, setIsOneCameraFullScreen] = useState(false);
  const [listCamera, setListCamera] = useState([]);
  const [refreshPath, setRefreshPath] = useState(false);
  const [isFullScreen, setIsFullScreen] = React.useState(false);
  const [showTaskbar, setShowTaskbar] = useState(false);
  const [groupCode, setGroupCode] = useState([]);
  const [oneThread, setOnThread] = useState(false);
  const [isSearchCam, setIsSearchCam] = useState(false);
  const [screenSearch, setScreenSearch] = useState({
    col: 1,
    row: 1,
    total: 1,
  })
  const [filterStatus, setFilterStatus] = useState({
    on: false,
    off: false,
    notConnect: false,
    weak: false,
  })
  const handleFullScreen = (name, streaming, type) => {
    if (type === "FullScreen") {
      if (!isOneCameraFullScreen) {
        const oneCamera = streaming.filter((item) => {
          return item?.name === name;
        });
        setCameraActive([...oneCamera]);
      } else {
        setListCamera([...streaming]);
      }
      setIsOneCameraFullScreen(!isOneCameraFullScreen);
    } else {
      const listCameraCode = streaming.map(item => {
        return {
          camera_code: item.code
        }
      })
      let screen = {
        col: 1,
        row: 1,
        total: 1,
      };
      if (listCameraCode.length <= 64) {
        screen = screens.find(item => item.total >= listCameraCode.length);
      }
      setScreenSearch(screen)
      setCameraSelect(listCameraCode)
      setIsFullScreen(!isFullScreen)
    }
  };
  React.useEffect(() => {
    const getCameraPriority = async () => {
      try {
        const res = await cameraManagement.getListPriority(isGroup);
        const data = res.map((item, index) => {
          return { camera_code: item.CAMERA_CODE };
        });
        const fillData = data.filter(
          (item, index) =>
            data.findIndex(
              (item_1) => item_1.camera_code === item.camera_code
            ) === index
        );
        setCameraSelect(fillData);
      } catch (e) {
        if (e?.response?.status === 403) {
          Toast.open("Bạn không quyền xem trưc tiếp camera", "danger");
        }
      }
    };
    if (!isSearchCam) {
      getCameraPriority();
    }
  }, [toggleReGetListCamera, dataStore.toggleNotification, isGroup, isSearchCam]);
  useEffect(() => {
    setScreen(
      sessionStorage.getItem("col") &&
        sessionStorage.getItem("row") &&
        sessionStorage.getItem("total")
        ? {
          col: Number(sessionStorage.getItem("col")),
          row: Number(sessionStorage.getItem("row")),
          total: Number(sessionStorage.getItem("total")),
        }
        : {
          col: 1,
          row: 1,
          total: 1,
        }
    );
    setIsGroup(sessionStorage.getItem("isGroup") === "false" ? false : true)
    if (sessionStorage.getItem("groupCode")) {
      setGroupCode(sessionStorage.getItem("groupCode"))
    }
  }, []);
  useEffect(() => {
    const handleMousemove = (e) => {
      if (isFullScreen && !showTaskbar) {
        setShowTaskbar(true);
        let time = setTimeout(() => {
          setShowTaskbar(false);
        }, 4000);
      }
    };

    document.addEventListener("click", handleMousemove);
    return () => {
      document.removeEventListener("click", handleMousemove);
    };
  }, [isFullScreen, showTaskbar]);
  return (
    <CameraContext.Provider
      value={{
        cameraSelect,
        setCameraSelect,
        isApply,
        setIsApply,
        setToggleReGetListCamera,
        toggleReGetListCamera,
        screen,
        setScreen,
        isLoadingCamera,
        setIsLoadingCamera,
        cameraActive,
        setCameraActive,
        isShowCameraActive,
        setIsShowCameraActive,
        stream,
        isOneCameraFullScreen,
        setIsOneCameraFullScreen,
        listCamera,
        setListCamera,
        handleFullScreen,
        setRefreshPath,
        refreshPath,
        isFullScreen,
        setIsFullScreen,
        showTaskbar,
        setShowTaskbar,
        isGroup,
        setIsGroup,
        currentPage,
        setCurrentPage,
        groupCode,
        setGroupCode,
        oneThread,
        setOnThread,
        isSearchCam,
        setIsSearchCam,
        screenSearch,
        filterStatus,
        setFilterStatus
      }}
    >
      {isLoading && stream.length > 0 ? (
        <></>
      ) : (
        <>{isShowCameraActive && <CameraActive />}</>
      )}
      <div className={cx("content")}>
        <Location />
        <Camera cameraSelect={cameraSelect} />
      </div>
    </CameraContext.Provider>
  );
};

export default LiveCamera;
